import AgreementView from './AgreementView';

export default AgreementView;
